import { Button, DateInput, FlexRow, Grid, IDateInputValue, SmallBodyText } from '../../../../../ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { IDocumentInformation } from './UploadDocumentContainer';
import styled from 'styled-components';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';
import { DocumentCategorySelector } from '../../categorySelect/DocumentCategorySelector';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export interface IUploadingDocumentInformation {
  onDeleteDocument: () => void;
  document: IDocumentInformation;
  onCategoryChange: (selectedCategory: IDocumentCategory) => void;
  onDateChange: (date: IDateInputValue) => void;
  dateRequiringStandardDocuments: (selectedCategory: IDocumentCategory | null) => boolean;
}

const StyledSmallBodyText = styled(SmallBodyText)`
  width: 530px;
  overflow-wrap: anywhere;
`;

export const UploadingDocumentInformation: React.FC<IUploadingDocumentInformation> = ({
  onDeleteDocument,
  document,
  onCategoryChange,
  onDateChange,
  dateRequiringStandardDocuments,
}) => {
  const dateLabel = document.category?.name?.includes('payoff') ? 'Expiration Date' : 'Due Date';

  return (
    <>
      <FlexRow justifyContent={'space-between'}>
        <StyledSmallBodyText>Provide details for {document.file.name}</StyledSmallBodyText>
        <Button intent={'danger'} onClick={onDeleteDocument}>
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </FlexRow>
      <Grid templateColumns={'414px'}>
        <DocumentCategorySelector
          selectedCategory={document.category}
          label={'Category'}
          isRequired
          onChange={(category: any) => onCategoryChange(category.value)}
        />

        {document.category?.internalDescription && (
          <>
            <SmallBodyText intent={'faded'} data-test-id={'doc-upload-category-internal-description-info-text'}>
              <FontAwesomeIcon icon={faInfoCircle} style={{ paddingRight: '6px' }} />
              {document.category?.internalDescription}
            </SmallBodyText>
          </>
        )}
        {dateRequiringStandardDocuments(document.category) && (
          <DateInput
            label={dateLabel}
            name={'dueDate'}
            placeholder={'mm/dd/yyyy'}
            isRequired
            attachPortalInsideContainter
            onChange={(date) => onDateChange(date)}
            value={getDateString(DateFormat.short, document.date?.dateValue)}
          />
        )}
      </Grid>
    </>
  );
};
